
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.667 8c0-2.986 0-4.478.927-5.406.928-.927 2.42-.927 5.406-.927 2.986 0 4.478 0 5.406.927.927.928.927 2.42.927 5.406 0 2.986 0 4.478-.927 5.406-.928.927-2.42.927-5.406.927-2.985 0-4.478 0-5.406-.927-.927-.928-.927-2.42-.927-5.406z","stroke":"#4FAEAF","stroke-width":"1.25"}}),_c('path',{attrs:{"d":"M8 10.667V5.333m0 5.334c-.467 0-1.339-1.33-1.667-1.667M8 10.667c.467 0 1.34-1.33 1.667-1.667","stroke":"#4FAEAF","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    